/* istanbul ignore file */
// ignore coverage test because this is configuration
import { useEffect } from 'react'
import { ConditionalRoute } from 'quick-quote/components/navigations/utils'
import { NeedAndGapAnalysisContainer } from 'quick-quote/fna'
import {
  canProceedToFundAllocation,
  canProceedToFundAndCoveragePlan,
  canProceedToRiskQuestionnaire,
  canProceedToIlpSaleSheetDoc,
} from 'quick-quote/product-investment/journey-control-selectors'

import { CoveragePlanContainer as LifeReadyCoveragePlanContainer } from 'quick-quote/product-life-ready/coverage-plan'
import { LoanBenefitIllustrationContainer } from 'quick-quote/product-loan/benefit-illustration'
import { LoanCoveragePlanContainer } from 'quick-quote/product-loan/coverage-plan'
import { BenefitIllustrationContainer as MRTABenefitIllustrationContainer } from 'quick-quote/product-mrta/benefit-illustration'
import { CoveragePlanContainer as MRTACoveragePlanContainer } from 'quick-quote/product-mrta/coverage-plan'
import { BenefitIllustrationContainer as PersonalAccidentBenefitIllustrationContainer } from 'quick-quote/product-pa/benefit-illustration'
import { CoveragePlanContainer as PersonalAccidentCoveragePlanContainer } from 'quick-quote/product-pa/coverage-plan'
import { CoveragePlanContainer as PerfectLifeCoveragePlanContainer } from 'quick-quote/product-perfect-life/coverage-plan'
import { BenefitIllustrationContainer as ProtectionBenefitIllustrationContainer } from 'quick-quote/product-protection/benefit-illustration'
import { CoveragePlanContainer as ProtectionCoveragePlanContainer } from 'quick-quote/product-protection/coverage-plan'
import { CoveragePlanContainer as RetirementCoveragePlanContainer } from 'quick-quote/product-retirement/coverage-plan'
import { CoveragePlanContainer as ProductSIOCoveragePlanContainer } from 'quick-quote/product-sio/coverage-plan'

import { MaturityValidateContainer } from 'quick-quote/product-sio/maturity-validate'
import { SelectPolicyOwnerContainer } from 'quick-quote/product-sio/select-policy-owner'
import { BenefitIllustrationContainer as SavingBenefitIllustrationContainer } from 'quick-quote/product-saving/benefit-illustration'
import { CoveragePlanContainer as SavingCoveragePlanContainer } from 'quick-quote/product-saving/coverage-plan'
import { BasicPlanSelectionContainer } from 'quick-quote/product-selection'
import { CoveragePlanContainer as SukhapabDekDeeCoveragePlanContainer } from 'quick-quote/product-sukhapabdekdee/coverage-plan'
import { BenefitIllustrationContainer as TermLifeBenefitIllustrationContainer } from 'quick-quote/product-term-life/benefit-illustration'
import { CoveragePlanContainer as TermLifeCoveragePlanContainer } from 'quick-quote/product-term-life/coverage-plan'
import { CoveragePlanContainer as WholeLifeCoveragePlanContainer } from 'quick-quote/product-whole-life/coverage-plan'
import InvestmentBenefitillustrationContainer from 'quick-quote/v2/products/categories/investment/benefit-illustration'
import SaleSheetPreview from 'quick-quote/components/preview-pdf'
import React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'
import { PATH, ROUTE_PATH } from '../../../constants/path'
import { MarketConductsContainer } from '../../../fna/market-conducts'
import {
  FlexiHealthInsuredInformationContainer,
  HealthInsuredInformationContainer,
  HealthToppingInsuredInformationContainer,
  InvestmentInsuredInformationContainer,
  LifeSaveProInsuredInformationContainer,
  LoanInsuredInformationContainer,
  PerfectLifeInsuredInformationContainer,
  SukhapabDekDeeInsuredInformationContainer,
  ProtectionInsuredInformationContainer,
  RetirementInsuredInformationContainer,
  SavingInsuredInformationContainer,
  WholeLifeInsuredInformationContainer,
  OrdinaryInsuredInformationContainer,
  LifeReadyInsuredInformationContainer,
  MRTAInsuredInformationContainer,
} from '../../../insured-information'
import { PortalContainer } from '../../../portal'
import {
  BenefitIllustrationContainer as HealthToppingBenefitIllustrationContainer,
  BenefitIllustrationContainer as FlexiHealthBenefitIllustrationContainer,
} from '../../../product-flexi-health/benefit-illustration'
import { CoveragePlanContainer as FlexiHealthCoveragePlanContainer } from '../../../product-flexi-health/coverage-plan'
import { CoveragePlanContainer as HealthToppingCoveragePlanContainer } from '../../../product-health-topping/coverage-plan'
import { BenefitIllustrationContainer as HealthBenefitIllustrationContainer } from '../../../product-health/benefit-illustration'
import { CoveragePlanContainer as HealthCoveragePlanContainer } from '../../../product-health/coverage-plan'
import { InvestmentCoveragePlanContainer } from '../../../product-investment/coverage-plan'
import LstuFundAllocationContainer from '../../../product-investment/fund-allocation/lstu/container'
import FundAllocationContainer from '../../../product-investment/fund-allocation/rpp/containers'
import { RiskContainer } from '../../../product-investment/risk-questionnaire'
import { BenefitIllustrationContainer as LifeSaveProBenefitIllustrationContainer } from '../../../product-life-save-pro/benefit-illustration'
import { CoveragePlanContainer as LifeSaveProCoveragePlanContainer } from '../../../product-life-save-pro/coverage-plan'
import { CoveragePlanContainer as BumnanReadyCoveragePlanContainer } from '../../../product-bumnan-ready/coverage-plan'
import { BenefitIllustrationContainer as PerfectLifeBenefitIllustrationContainer } from '../../../v2/products/categories/perfect-life/benefit-illustration'
import { BenefitIllustrationContainer as SukhapabDekDeeBenefitIllustrationContainer } from '../../../v2/products/categories/sukhapabdekdee/benefit-illustration'
import { BenefitIllustrationContainer as RetirementBenefitIllustrationContainer } from '../../../v2/products/categories/retirement/benefit-illustration'
import { BenefitIllustrationContainer as WholeLifeBenefitIllustrationContainer } from '../../../v2/products/categories/whole-life/benefit-illustration'
import { CoveragePlanContainer as IHealthyUltraCoveragePlanContainer } from '../../../product-ihealthy-ultra/coverage-plan'
import { BenefitIllustrationContainer as IHealthyUltraBenefitIllustrationContainer } from '../../../product-ihealthy-ultra/benefit-illustration'

import { getToggles } from '../../../feature-toggles'

const redirectToLandingPage = ({ history, location }) => {
  if (history.action === 'POP' && location.pathname.endsWith(ROUTE_PATH.WHOLE_LIFE.BENEFIT_ILLUSTRATION)) {
    history.replace(ROUTE_PATH.PRODUCT_SELECTION)
  }
}

const FNA = (props) => {
  const { match, history, location } = props
  useEffect(() => {
    redirectToLandingPage({ history, location })
  }, [history, location])

  return (
    <Switch>
      <Route
        path={`${match.path}${PATH.PRODUCT_SELECTION}`}
        component={props.logPageView(BasicPlanSelectionContainer)}
      />
      <Route path={`${match.path}${PATH.PORTAL}`} component={props.logPageView(PortalContainer)} />
      <Route
        path={`${match.path}${PATH.NEED_AND_GAP_ANALYSIS}`}
        component={props.logPageView(NeedAndGapAnalysisContainer)}
      />
      {getToggles().ENABLE_FNA_V3 && (
        <Route path={`${match.path}${PATH.MARKET_CONDUCTS}`} component={props.logPageView(MarketConductsContainer)} />
      )}
      {/* === whole life === */}
      <Route
        path={`${match.path}${ROUTE_PATH.WHOLE_LIFE.NEED_AND_GAP_ANALYSIS}`}
        component={props.logPageView(NeedAndGapAnalysisContainer)}
      />
      <Route
        path={`${match.path}${ROUTE_PATH.WHOLE_LIFE.PRODUCT_SELECTION}`}
        component={props.logPageView(BasicPlanSelectionContainer)}
      />
      <Route
        path={`${match.path}${ROUTE_PATH.WHOLE_LIFE.MARKET_CONDUCTS}`}
        component={props.logPageView(MarketConductsContainer)}
      />
      <Route
        path={`${match.path}${ROUTE_PATH.WHOLE_LIFE.INSURED_INFORMATION}`}
        component={props.logPageView(WholeLifeInsuredInformationContainer)}
      />
      <Route
        path={`${match.path}${ROUTE_PATH.WHOLE_LIFE.COVERAGE_PLAN}`}
        component={props.logPageView(WholeLifeCoveragePlanContainer)}
      />
      <Route
        path={`${match.path}${ROUTE_PATH.WHOLE_LIFE.BENEFIT_ILLUSTRATION}`}
        component={WholeLifeBenefitIllustrationContainer}
      />
      {/* === s7cc === */}
      <Route
        path={`${match.path}${ROUTE_PATH.S7CC.NEED_AND_GAP_ANALYSIS}`}
        component={props.logPageView(NeedAndGapAnalysisContainer)}
      />
      <Route
        path={`${match.path}${ROUTE_PATH.S7CC.PRODUCT_SELECTION}`}
        component={props.logPageView(BasicPlanSelectionContainer)}
      />
      <Route
        path={`${match.path}${ROUTE_PATH.S7CC.MARKET_CONDUCTS}`}
        component={props.logPageView(MarketConductsContainer)}
      />
      <Route
        path={`${match.path}${ROUTE_PATH.S7CC.MATURITY_VALIDATE}`}
        component={props.logPageView(MaturityValidateContainer)}
      />
      <Route
        path={`${match.path}${ROUTE_PATH.S7CC.SELECT_POLICY_OWNER}`}
        component={props.logPageView(SelectPolicyOwnerContainer)}
      />
      <Route
        path={`${match.path}${ROUTE_PATH.S7CC.INSURED_INFORMATION}`}
        component={props.logPageView(OrdinaryInsuredInformationContainer)}
      />
      <Route
        path={`${match.path}${ROUTE_PATH.S7CC.COVERAGE_PLAN}`}
        component={props.logPageView(WholeLifeCoveragePlanContainer)}
      />
      <Route
        path={`${match.path}${ROUTE_PATH.S7CC.BENEFIT_ILLUSTRATION}`}
        component={WholeLifeBenefitIllustrationContainer}
      />
      {/* === term life === */}
      <Route
        path={`${match.path}${ROUTE_PATH.TERM_LIFE.NEED_AND_GAP_ANALYSIS}`}
        component={props.logPageView(NeedAndGapAnalysisContainer)}
      />
      <Route
        path={`${match.path}${ROUTE_PATH.TERM_LIFE.PRODUCT_SELECTION}`}
        component={props.logPageView(BasicPlanSelectionContainer)}
      />
      <Route
        path={`${match.path}${ROUTE_PATH.TERM_LIFE.MARKET_CONDUCTS}`}
        component={props.logPageView(MarketConductsContainer)}
      />
      <Route
        path={`${match.path}${ROUTE_PATH.TERM_LIFE.INSURED_INFORMATION}`}
        component={props.logPageView(WholeLifeInsuredInformationContainer)}
      />
      <Route
        path={`${match.path}${ROUTE_PATH.TERM_LIFE.COVERAGE_PLAN}`}
        component={props.logPageView(TermLifeCoveragePlanContainer)}
      />
      <Route
        path={`${match.path}${ROUTE_PATH.TERM_LIFE.BENEFIT_ILLUSTRATION}`}
        component={TermLifeBenefitIllustrationContainer}
      />
      {/* === index linked === */}
      <Route
        path={`${match.path}${ROUTE_PATH.INDEX_LINKED.NEED_AND_GAP_ANALYSIS}`}
        component={props.logPageView(NeedAndGapAnalysisContainer)}
      />
      <Route
        path={`${match.path}${ROUTE_PATH.INDEX_LINKED.PRODUCT_SELECTION}`}
        component={props.logPageView(BasicPlanSelectionContainer)}
      />
      <Route
        path={`${match.path}${ROUTE_PATH.INDEX_LINKED.MARKET_CONDUCTS}`}
        component={props.logPageView(MarketConductsContainer)}
      />
      <Route
        path={`${match.path}${ROUTE_PATH.INDEX_LINKED.INSURED_INFORMATION}`}
        component={props.logPageView(WholeLifeInsuredInformationContainer)}
      />
      <Route
        path={`${match.path}${ROUTE_PATH.INDEX_LINKED.COVERAGE_PLAN}`}
        component={props.logPageView(TermLifeCoveragePlanContainer)}
      />
      <Route
        path={`${match.path}${ROUTE_PATH.INDEX_LINKED.BENEFIT_ILLUSTRATION}`}
        component={TermLifeBenefitIllustrationContainer}
      />
      {/* === protection === */}
      <Route
        path={`${match.path}${ROUTE_PATH.PROTECTION.NEED_AND_GAP_ANALYSIS}`}
        component={props.logPageView(NeedAndGapAnalysisContainer)}
      />
      <Route
        path={`${match.path}${ROUTE_PATH.PROTECTION.PRODUCT_SELECTION}`}
        component={props.logPageView(BasicPlanSelectionContainer)}
      />
      <Route
        path={`${match.path}${ROUTE_PATH.PROTECTION.MARKET_CONDUCTS}`}
        component={props.logPageView(MarketConductsContainer)}
      />
      <Route
        path={`${match.path}${ROUTE_PATH.PROTECTION.INSURED_INFORMATION}`}
        component={props.logPageView(ProtectionInsuredInformationContainer)}
      />
      <Route
        path={`${match.path}${ROUTE_PATH.PROTECTION.COVERAGE_PLAN}`}
        component={props.logPageView(ProtectionCoveragePlanContainer)}
      />
      <Route
        path={`${match.path}${ROUTE_PATH.PROTECTION.BENEFIT_ILLUSTRATION}`}
        component={ProtectionBenefitIllustrationContainer}
      />
      {/* === health === */}

      <Route
        path={`${match.path}${ROUTE_PATH.HEALTH.NEED_AND_GAP_ANALYSIS}`}
        component={props.logPageView(NeedAndGapAnalysisContainer)}
      />
      <Route
        path={`${match.path}${ROUTE_PATH.HEALTH.PRODUCT_SELECTION}`}
        component={props.logPageView(BasicPlanSelectionContainer)}
      />
      <Route
        path={`${match.path}${ROUTE_PATH.HEALTH.MARKET_CONDUCTS}`}
        component={props.logPageView(MarketConductsContainer)}
      />
      <Route
        path={`${match.path}${ROUTE_PATH.HEALTH.INSURED_INFORMATION}`}
        component={props.logPageView(HealthInsuredInformationContainer)}
      />
      <Route
        path={`${match.path}${ROUTE_PATH.HEALTH.COVERAGE_PLAN}`}
        component={props.logPageView(HealthCoveragePlanContainer)}
      />
      <Route
        path={`${match.path}${ROUTE_PATH.HEALTH.BENEFIT_ILLUSTRATION}`}
        component={HealthBenefitIllustrationContainer}
      />

      {/* === health ultra === */}

      <Route
        path={`${match.path}${ROUTE_PATH.IHEALTHY_ULTRA.NEED_AND_GAP_ANALYSIS}`}
        component={props.logPageView(NeedAndGapAnalysisContainer)}
      />
      <Route
        path={`${match.path}${ROUTE_PATH.IHEALTHY_ULTRA.PRODUCT_SELECTION}`}
        component={props.logPageView(BasicPlanSelectionContainer)}
      />
      <Route
        path={`${match.path}${ROUTE_PATH.IHEALTHY_ULTRA.MARKET_CONDUCTS}`}
        component={props.logPageView(MarketConductsContainer)}
      />
      <Route
        path={`${match.path}${ROUTE_PATH.IHEALTHY_ULTRA.INSURED_INFORMATION}`}
        // component={props.logPageView(IHealthyUltraInsuredInformationContainer)}
        component={props.logPageView(OrdinaryInsuredInformationContainer)}
      />
      <Route
        path={`${match.path}${ROUTE_PATH.IHEALTHY_ULTRA.COVERAGE_PLAN}`}
        component={props.logPageView(IHealthyUltraCoveragePlanContainer)}
      />
      <Route
        path={`${match.path}${ROUTE_PATH.IHEALTHY_ULTRA.BENEFIT_ILLUSTRATION}`}
        component={IHealthyUltraBenefitIllustrationContainer}
      />

      {/* === investment === */}
      <Route
        path={`${match.path}${ROUTE_PATH.INVESTMENT.NEED_AND_GAP_ANALYSIS}`}
        component={props.logPageView(NeedAndGapAnalysisContainer)}
      />
      <Route
        path={`${match.path}${ROUTE_PATH.INVESTMENT.PRODUCT_SELECTION}`}
        component={props.logPageView(BasicPlanSelectionContainer)}
      />
      <Route
        path={`${match.path}${ROUTE_PATH.INVESTMENT.MARKET_CONDUCTS}`}
        component={props.logPageView(MarketConductsContainer)}
      />
      <ConditionalRoute
        path={`${match.path}${ROUTE_PATH.INVESTMENT.ILP_SALE_SHEET}`}
        component={props.logPageView(SaleSheetPreview)}
        conditions={[canProceedToIlpSaleSheetDoc]}
        redirect={<Redirect to={ROUTE_PATH.PORTAL} />}
      />
      <Route
        path={`${match.path}${ROUTE_PATH.INVESTMENT.INSURED_INFORMATION}`}
        component={props.logPageView(InvestmentInsuredInformationContainer)}
      />
      <Route
        path={`${match.path}${ROUTE_PATH.INVESTMENT.RISK_QUESTIONNAIRE}`}
        component={props.logPageView(RiskContainer)}
      />
      <ConditionalRoute
        path={`${match.path}${ROUTE_PATH.INVESTMENT.COVERAGE_PLAN}`}
        component={props.logPageView(InvestmentCoveragePlanContainer)}
        conditions={[canProceedToRiskQuestionnaire]}
        redirect={<Redirect to={ROUTE_PATH.PORTAL} />}
      />
      <ConditionalRoute
        path={`${match.path}${ROUTE_PATH.INVESTMENT.FUND_ALLOCATION}`}
        component={props.logPageView(FundAllocationContainer)}
        conditions={[canProceedToFundAndCoveragePlan]}
        redirect={<Redirect to={ROUTE_PATH.PORTAL} />}
      />
      <ConditionalRoute
        path={`${match.path}${ROUTE_PATH.INVESTMENT.LSTU_FUND_ALLOCATION}`}
        component={props.logPageView(LstuFundAllocationContainer)}
        conditions={[canProceedToFundAllocation]}
        redirect={<Redirect to={ROUTE_PATH.PORTAL} />}
      />
      <Route
        path={`${match.path}${ROUTE_PATH.INVESTMENT.BENEFIT_ILLUSTRATION}`}
        component={props.logPageView(InvestmentBenefitillustrationContainer)}
      />
      {/* === loan === */}
      <Route
        path={`${match.path}${ROUTE_PATH.LOAN.NEED_AND_GAP_ANALYSIS}`}
        component={props.logPageView(NeedAndGapAnalysisContainer)}
      />
      <Route
        path={`${match.path}${ROUTE_PATH.LOAN.PRODUCT_SELECTION}`}
        component={props.logPageView(BasicPlanSelectionContainer)}
      />
      <Route
        path={`${match.path}${ROUTE_PATH.LOAN.MARKET_CONDUCTS}`}
        component={props.logPageView(MarketConductsContainer)}
      />
      <Route
        path={`${match.path}${ROUTE_PATH.LOAN.INSURED_INFORMATION}`}
        component={props.logPageView(LoanInsuredInformationContainer)}
      />
      <Route
        path={`${match.path}${ROUTE_PATH.LOAN.COVERAGE_PLAN}`}
        component={props.logPageView(LoanCoveragePlanContainer)}
      />
      <Route
        path={`${match.path}${ROUTE_PATH.LOAN.BENEFIT_ILLUSTRATION}`}
        component={LoanBenefitIllustrationContainer}
      />
      {/* === saving === */}
      <Route
        path={`${match.path}${ROUTE_PATH.SAVING.NEED_AND_GAP_ANALYSIS}`}
        component={props.logPageView(NeedAndGapAnalysisContainer)}
      />
      <Route
        path={`${match.path}${ROUTE_PATH.SAVING.PRODUCT_SELECTION}`}
        component={props.logPageView(BasicPlanSelectionContainer)}
      />
      <Route
        path={`${match.path}${ROUTE_PATH.SAVING.MARKET_CONDUCTS}`}
        component={props.logPageView(MarketConductsContainer)}
      />
      <Route
        path={`${match.path}${ROUTE_PATH.SAVING.INSURED_INFORMATION}`}
        component={props.logPageView(SavingInsuredInformationContainer)}
      />
      <Route
        path={`${match.path}${ROUTE_PATH.SAVING.COVERAGE_PLAN}`}
        component={props.logPageView(SavingCoveragePlanContainer)}
      />
      <Route
        path={`${match.path}${ROUTE_PATH.SAVING.BENEFIT_ILLUSTRATION}`}
        component={SavingBenefitIllustrationContainer}
      />
      {/* === life-save-pro === */}
      <Route
        path={`${match.path}${ROUTE_PATH.LIFE_SAVE_PRO.NEED_AND_GAP_ANALYSIS}`}
        component={props.logPageView(NeedAndGapAnalysisContainer)}
      />
      <Route
        path={`${match.path}${ROUTE_PATH.LIFE_SAVE_PRO.PRODUCT_SELECTION}`}
        component={props.logPageView(BasicPlanSelectionContainer)}
      />
      <Route
        path={`${match.path}${ROUTE_PATH.LIFE_SAVE_PRO.MARKET_CONDUCTS}`}
        component={props.logPageView(MarketConductsContainer)}
      />
      <Route
        path={`${match.path}${ROUTE_PATH.LIFE_SAVE_PRO.INSURED_INFORMATION}`}
        component={props.logPageView(LifeSaveProInsuredInformationContainer)}
      />
      <Route
        path={`${match.path}${ROUTE_PATH.LIFE_SAVE_PRO.COVERAGE_PLAN}`}
        component={props.logPageView(LifeSaveProCoveragePlanContainer)}
      />
      <Route
        path={`${match.path}${ROUTE_PATH.LIFE_SAVE_PRO.BENEFIT_ILLUSTRATION}`}
        component={LifeSaveProBenefitIllustrationContainer}
      />
      {/* === flexi-health === */}
      <Route
        path={`${match.path}${ROUTE_PATH.FLEXI_HEALTH.NEED_AND_GAP_ANALYSIS}`}
        component={props.logPageView(NeedAndGapAnalysisContainer)}
      />
      <Route
        path={`${match.path}${ROUTE_PATH.FLEXI_HEALTH.PRODUCT_SELECTION}`}
        component={props.logPageView(BasicPlanSelectionContainer)}
      />
      <Route
        path={`${match.path}${ROUTE_PATH.FLEXI_HEALTH.MARKET_CONDUCTS}`}
        component={props.logPageView(MarketConductsContainer)}
      />
      <Route
        path={`${match.path}${ROUTE_PATH.FLEXI_HEALTH.INSURED_INFORMATION}`}
        component={props.logPageView(FlexiHealthInsuredInformationContainer)}
      />
      <Route
        path={`${match.path}${ROUTE_PATH.FLEXI_HEALTH.COVERAGE_PLAN}`}
        component={props.logPageView(FlexiHealthCoveragePlanContainer)}
      />
      <Route
        path={`${match.path}${ROUTE_PATH.FLEXI_HEALTH.BENEFIT_ILLUSTRATION}`}
        component={FlexiHealthBenefitIllustrationContainer}
      />

      {/* === retirement === */}
      <Route
        path={`${match.path}${ROUTE_PATH.RETIREMENT.NEED_AND_GAP_ANALYSIS}`}
        component={props.logPageView(NeedAndGapAnalysisContainer)}
      />
      <Route
        path={`${match.path}${ROUTE_PATH.RETIREMENT.PRODUCT_SELECTION}`}
        component={props.logPageView(BasicPlanSelectionContainer)}
      />
      <Route
        path={`${match.path}${ROUTE_PATH.RETIREMENT.MARKET_CONDUCTS}`}
        component={props.logPageView(MarketConductsContainer)}
      />
      <Route
        path={`${match.path}${ROUTE_PATH.RETIREMENT.INSURED_INFORMATION}`}
        component={props.logPageView(RetirementInsuredInformationContainer)}
      />
      <Route
        path={`${match.path}${ROUTE_PATH.RETIREMENT.COVERAGE_PLAN}`}
        component={props.logPageView(RetirementCoveragePlanContainer)}
      />
      <Route
        path={`${match.path}${ROUTE_PATH.RETIREMENT.BENEFIT_ILLUSTRATION}`}
        component={RetirementBenefitIllustrationContainer}
      />

      {/* === bumnan-ready === */}
      <Route
        path={`${match.path}${ROUTE_PATH.BUMNAN_READY.NEED_AND_GAP_ANALYSIS}`}
        component={props.logPageView(NeedAndGapAnalysisContainer)}
      />
      <Route
        path={`${match.path}${ROUTE_PATH.BUMNAN_READY.PRODUCT_SELECTION}`}
        component={props.logPageView(BasicPlanSelectionContainer)}
      />
      <Route
        path={`${match.path}${ROUTE_PATH.BUMNAN_READY.MARKET_CONDUCTS}`}
        component={props.logPageView(MarketConductsContainer)}
      />
      <Route
        path={`${match.path}${ROUTE_PATH.BUMNAN_READY.INSURED_INFORMATION}`}
        component={props.logPageView(RetirementInsuredInformationContainer)}
      />
      <Route
        path={`${match.path}${ROUTE_PATH.BUMNAN_READY.COVERAGE_PLAN}`}
        component={props.logPageView(BumnanReadyCoveragePlanContainer)}
      />
      <Route
        path={`${match.path}${ROUTE_PATH.BUMNAN_READY.BENEFIT_ILLUSTRATION}`}
        component={RetirementBenefitIllustrationContainer}
      />

      {/* === perfect-life === */}
      <Route
        path={`${match.path}${ROUTE_PATH.PERFECT_LIFE.NEED_AND_GAP_ANALYSIS}`}
        component={props.logPageView(NeedAndGapAnalysisContainer)}
      />
      <Route
        path={`${match.path}${ROUTE_PATH.PERFECT_LIFE.PRODUCT_SELECTION}`}
        component={props.logPageView(BasicPlanSelectionContainer)}
      />
      <Route
        path={`${match.path}${ROUTE_PATH.PERFECT_LIFE.MARKET_CONDUCTS}`}
        component={props.logPageView(MarketConductsContainer)}
      />
      <Route
        path={`${match.path}${ROUTE_PATH.PERFECT_LIFE.INSURED_INFORMATION}`}
        component={props.logPageView(PerfectLifeInsuredInformationContainer)}
      />
      <Route
        path={`${match.path}${ROUTE_PATH.PERFECT_LIFE.COVERAGE_PLAN}`}
        component={props.logPageView(PerfectLifeCoveragePlanContainer)}
      />
      <Route
        path={`${match.path}${ROUTE_PATH.PERFECT_LIFE.BENEFIT_ILLUSTRATION}`}
        component={PerfectLifeBenefitIllustrationContainer}
      />

      {/* === sukhapabdekdee === */}
      <Route
        path={`${match.path}${ROUTE_PATH.SUKHAPABDEKDEE.NEED_AND_GAP_ANALYSIS}`}
        component={props.logPageView(NeedAndGapAnalysisContainer)}
      />
      <Route
        path={`${match.path}${ROUTE_PATH.SUKHAPABDEKDEE.MARKET_CONDUCTS}`}
        component={props.logPageView(MarketConductsContainer)}
      />
      <Route
        path={`${match.path}${ROUTE_PATH.SUKHAPABDEKDEE.PRODUCT_SELECTION}`}
        component={props.logPageView(BasicPlanSelectionContainer)}
      />
      <Route
        path={`${match.path}${ROUTE_PATH.SUKHAPABDEKDEE.INSURED_INFORMATION}`}
        component={props.logPageView(SukhapabDekDeeInsuredInformationContainer)}
      />
      <Route
        path={`${match.path}${ROUTE_PATH.SUKHAPABDEKDEE.COVERAGE_PLAN}`}
        component={props.logPageView(SukhapabDekDeeCoveragePlanContainer)}
      />
      <Route
        path={`${match.path}${ROUTE_PATH.SUKHAPABDEKDEE.BENEFIT_ILLUSTRATION}`}
        component={SukhapabDekDeeBenefitIllustrationContainer}
      />

      {/* === health-topping === */}
      <Route
        path={`${match.path}${ROUTE_PATH.HEALTH_TOPPING.NEED_AND_GAP_ANALYSIS}`}
        component={props.logPageView(NeedAndGapAnalysisContainer)}
      />
      <Route
        path={`${match.path}${ROUTE_PATH.HEALTH_TOPPING.PRODUCT_SELECTION}`}
        component={props.logPageView(BasicPlanSelectionContainer)}
      />
      <Route
        path={`${match.path}${ROUTE_PATH.HEALTH_TOPPING.MARKET_CONDUCTS}`}
        component={props.logPageView(MarketConductsContainer)}
      />
      <Route
        path={`${match.path}${ROUTE_PATH.HEALTH_TOPPING.INSURED_INFORMATION}`}
        component={props.logPageView(HealthToppingInsuredInformationContainer)}
      />
      <Route
        path={`${match.path}${ROUTE_PATH.HEALTH_TOPPING.COVERAGE_PLAN}`}
        component={props.logPageView(HealthToppingCoveragePlanContainer)}
      />
      <Route
        path={`${match.path}${ROUTE_PATH.HEALTH_TOPPING.BENEFIT_ILLUSTRATION}`}
        component={HealthToppingBenefitIllustrationContainer}
      />

      {/* === life-ready === */}
      <Route
        path={`${match.path}${ROUTE_PATH.LIFE_READY.NEED_AND_GAP_ANALYSIS}`}
        component={props.logPageView(NeedAndGapAnalysisContainer)}
      />
      <Route
        path={`${match.path}${ROUTE_PATH.LIFE_READY.PRODUCT_SELECTION}`}
        component={props.logPageView(BasicPlanSelectionContainer)}
      />
      <Route
        path={`${match.path}${ROUTE_PATH.LIFE_READY.MARKET_CONDUCTS}`}
        component={props.logPageView(MarketConductsContainer)}
      />
      <Route
        path={`${match.path}${ROUTE_PATH.LIFE_READY.INSURED_INFORMATION}`}
        component={props.logPageView(LifeReadyInsuredInformationContainer)}
      />
      <Route
        path={`${match.path}${ROUTE_PATH.LIFE_READY.COVERAGE_PLAN}`}
        component={props.logPageView(LifeReadyCoveragePlanContainer)}
      />
      <Route
        path={`${match.path}${ROUTE_PATH.LIFE_READY.BENEFIT_ILLUSTRATION}`}
        component={WholeLifeBenefitIllustrationContainer}
      />

      {/* === mrta === */}
      <Route
        path={`${match.path}${ROUTE_PATH.MRTA.NEED_AND_GAP_ANALYSIS}`}
        component={props.logPageView(NeedAndGapAnalysisContainer)}
      />
      <Route
        path={`${match.path}${ROUTE_PATH.MRTA.PRODUCT_SELECTION}`}
        component={props.logPageView(BasicPlanSelectionContainer)}
      />
      <Route
        path={`${match.path}${ROUTE_PATH.MRTA.MARKET_CONDUCTS}`}
        component={props.logPageView(MarketConductsContainer)}
      />
      <Route
        path={`${match.path}${ROUTE_PATH.MRTA.INSURED_INFORMATION}`}
        component={props.logPageView(MRTAInsuredInformationContainer)}
      />
      <Route
        path={`${match.path}${ROUTE_PATH.MRTA.COVERAGE_PLAN}`}
        component={props.logPageView(MRTACoveragePlanContainer)}
      />
      <Route
        path={`${match.path}${ROUTE_PATH.MRTA.BENEFIT_ILLUSTRATION}`}
        component={MRTABenefitIllustrationContainer}
      />

      {/* === pa (personal accident) === */}
      <Route
        path={`${match.path}${ROUTE_PATH.PA.NEED_AND_GAP_ANALYSIS}`}
        component={props.logPageView(NeedAndGapAnalysisContainer)}
      />
      <Route
        path={`${match.path}${ROUTE_PATH.PA.PRODUCT_SELECTION}`}
        component={props.logPageView(BasicPlanSelectionContainer)}
      />
      <Route
        path={`${match.path}${ROUTE_PATH.PA.MARKET_CONDUCTS}`}
        component={props.logPageView(MarketConductsContainer)}
      />
      <Route
        path={`${match.path}${ROUTE_PATH.PA.INSURED_INFORMATION}`}
        component={props.logPageView(WholeLifeInsuredInformationContainer)}
      />
      <Route
        path={`${match.path}${ROUTE_PATH.PA.COVERAGE_PLAN}`}
        component={props.logPageView(PersonalAccidentCoveragePlanContainer)}
      />
      <Route
        path={`${match.path}${ROUTE_PATH.PA.BENEFIT_ILLUSTRATION}`}
        component={PersonalAccidentBenefitIllustrationContainer}
      />

      {/* === product-sio === */}
      <Route
        path={`${match.path}${ROUTE_PATH.PRODUCT_SIO.NEED_AND_GAP_ANALYSIS}`}
        component={props.logPageView(NeedAndGapAnalysisContainer)}
      />
      <Route
        path={`${match.path}${ROUTE_PATH.PRODUCT_SIO.PRODUCT_SELECTION}`}
        component={props.logPageView(BasicPlanSelectionContainer)}
      />
      <Route
        path={`${match.path}${ROUTE_PATH.PRODUCT_SIO.MARKET_CONDUCTS}`}
        component={props.logPageView(MarketConductsContainer)}
      />
      <Route
        path={`${match.path}${ROUTE_PATH.PRODUCT_SIO.MATURITY_VALIDATE}`}
        component={props.logPageView(MaturityValidateContainer)}
      />
      <Route
        path={`${match.path}${ROUTE_PATH.PRODUCT_SIO.INSURED_INFORMATION}`}
        component={props.logPageView(LifeReadyInsuredInformationContainer)}
      />
      <Route
        path={`${match.path}${ROUTE_PATH.PRODUCT_SIO.COVERAGE_PLAN}`}
        component={props.logPageView(ProductSIOCoveragePlanContainer)}
      />
      <Route
        path={`${match.path}${ROUTE_PATH.PRODUCT_SIO.BENEFIT_ILLUSTRATION}`}
        component={WholeLifeBenefitIllustrationContainer}
      />

    {/* === product-gio-preuw === */}
    <Route
      path={`${match.path}${ROUTE_PATH.PRODUCT_GIO_PREUW.NEED_AND_GAP_ANALYSIS}`}
      component={props.logPageView(NeedAndGapAnalysisContainer)}
    />
    <Route
      path={`${match.path}${ROUTE_PATH.PRODUCT_GIO_PREUW.PRODUCT_SELECTION}`}
      component={props.logPageView(BasicPlanSelectionContainer)}
    />
    <Route
      path={`${match.path}${ROUTE_PATH.PRODUCT_GIO_PREUW.MARKET_CONDUCTS}`}
      component={props.logPageView(MarketConductsContainer)}
    />
    <Route
      path={`${match.path}${ROUTE_PATH.PRODUCT_GIO_PREUW.MATURITY_VALIDATE}`}
      component={props.logPageView(MaturityValidateContainer)}
    />
    <Route
      path={`${match.path}${ROUTE_PATH.PRODUCT_GIO_PREUW.INSURED_INFORMATION}`}
      component={props.logPageView(WholeLifeInsuredInformationContainer)}
    />
    <Route
      path={`${match.path}${ROUTE_PATH.PRODUCT_GIO_PREUW.COVERAGE_PLAN}`}
      component={props.logPageView(WholeLifeCoveragePlanContainer)}
    />
    <Route
      path={`${match.path}${ROUTE_PATH.PRODUCT_GIO_PREUW.BENEFIT_ILLUSTRATION}`}
      component={WholeLifeBenefitIllustrationContainer}
    />

    {/* === life-protect-plus === */}
    <Route
      path={`${match.path}${ROUTE_PATH.LIFE_PROTECT_PLUS.NEED_AND_GAP_ANALYSIS}`}
      component={props.logPageView(NeedAndGapAnalysisContainer)}
    />
    <Route
      path={`${match.path}${ROUTE_PATH.LIFE_PROTECT_PLUS.PRODUCT_SELECTION}`}
      component={props.logPageView(BasicPlanSelectionContainer)}
    />
    <Route
      path={`${match.path}${ROUTE_PATH.LIFE_PROTECT_PLUS.MARKET_CONDUCTS}`}
      component={props.logPageView(MarketConductsContainer)}
    />
    <Route
      path={`${match.path}${ROUTE_PATH.LIFE_PROTECT_PLUS.INSURED_INFORMATION}`}
      component={props.logPageView(LifeReadyInsuredInformationContainer)}
    />
    <Route
      path={`${match.path}${ROUTE_PATH.LIFE_PROTECT_PLUS.COVERAGE_PLAN}`}
      component={props.logPageView(LifeReadyCoveragePlanContainer)}
    />
    <Route
      path={`${match.path}${ROUTE_PATH.LIFE_PROTECT_PLUS.BENEFIT_ILLUSTRATION}`}
      component={WholeLifeBenefitIllustrationContainer}
    />
      <Redirect from="/" to={ROUTE_PATH.PORTAL} />
    </Switch>
  )
}

export default FNA
